"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var blockConfigUtil_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/blockConfigUtil");
var defaultAcceptBlockStyle_1 = __importDefault(require("./defaultAcceptBlockStyle"));
var defaultQuoteBlockStyle_1 = __importDefault(require("./defaultQuoteBlockStyle"));
var defaultSourceBlockStyle_1 = __importDefault(require("./defaultSourceBlockStyle"));
var defaultSplashBlockStyle_1 = __importDefault(require("./defaultSplashBlockStyle"));
var defaultTextBlockStyle_1 = __importDefault(require("./defaultTextBlockStyle"));
var defaultAgreementBlockStyle_1 = __importDefault(require("./defaultAgreementBlockStyle"));
exports.default = (function (blockType, colors) {
    switch (blockType) {
        case commonTypes_1.BlockType.Quote:
            return (0, blockConfigUtil_1.addHash)((0, defaultQuoteBlockStyle_1.default)(colors));
        case commonTypes_1.BlockType.Source:
            return (0, blockConfigUtil_1.addHash)((0, defaultSourceBlockStyle_1.default)());
        case commonTypes_1.BlockType.Splash:
            return (0, blockConfigUtil_1.addHash)((0, defaultSplashBlockStyle_1.default)(colors));
        case commonTypes_1.BlockType.Accept:
            return (0, blockConfigUtil_1.addHash)((0, defaultAcceptBlockStyle_1.default)(colors));
        case commonTypes_1.BlockType.Agreement:
            return (0, blockConfigUtil_1.addHash)((0, defaultAgreementBlockStyle_1.default)(colors));
        default:
            return (0, blockConfigUtil_1.addHash)((0, defaultTextBlockStyle_1.default)(colors));
    }
});
